import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { isSuperAdminRequest } from './super-admin.interceptor';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const token = auth.getToken();

  // Login and password endpoints are public and need no token; superbeheer sends a key of its own
  if (!token || req.url.includes('/auth/') || isSuperAdminRequest(req.url)) {
    return next(req);
  }

  const clonedRequest = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`
    }
  });

  // Process the request and keep the refreshed token (and the role and status in it) from the response headers
  return next(clonedRequest).pipe(
    tap(event => {
      if (event instanceof HttpResponse) {
        const refreshedToken = event.headers.get('X-Auth-Token');

        if (refreshedToken) {
          auth.storeToken(refreshedToken);
        }
      }
    })
  );
};
